import { CoordinatorService } from './coordinator.service';
import { Notepad } from './notepad';

export class ScriptNotepad {
    #coords: CoordinatorService;
    #notepad: Notepad;

    constructor(coords: CoordinatorService, notepad: Notepad) {
        this.#coords = coords;
        this.#notepad = notepad;
    }

    get id() {
        return this.#notepad.id;
    }

    get title() {
        return this.#notepad.title;
    }

    addItem(body?: string) {
        const itm = this.#notepad.addItem();
        if (body) itm.body = body;
        return itm.scriptClass;
    }

    display() {
        this.#coords.notepad$.current = this.#notepad;
    }

    get size() {
        return this.#notepad.itemLs.length;
    }

    log(prefix = 'Notepad') {
        console.log(`${prefix}: ${this.#notepad.title} (${this.size})`);
    }

    json() {
        return this.#notepad.json();
    }

    get evidenceXitemIdSet() {
        return this.#notepad.evidenceXitemIdSet;
    }
}
